import React from "react";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import AddIcon from "@mui/icons-material/Add";
import { isOpenPopup } from "../../utils";
import { allowedToCreateEntity } from "src/constants/role";
import useAuth from "src/hooks/useAuth";
import Controls from "src/components/form/controls/Controls";
import { TTSContextType } from "../../constants";

const TTSContextControlPanel = ({
  permissionsAccessControl,
  handleOpenPopup,
  children,
  isShowButtonInit,
  initEmptyContext,
  isShowButtonUpdate,
  updateEmptyContext,
  isShowButtonInitError,
  initEmptyContextError,
  isShowButtonUpdateError,
  updateEmptyContextError,
}) => {
  const { auth } = useAuth();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        {isShowButtonInit && (
          <Controls.Button
            text="Init Empty Context Success"
            variant="outlined"
            startIcon={<RestartAltIcon />}
            onClick={() => initEmptyContext(TTSContextType.SUCCESS_EMPTY)}
          />
        )}
        {isShowButtonUpdate && (
          <Controls.Button
            text="Update Empty Context Success"
            variant="outlined"
            startIcon={<RestartAltIcon />}
            onClick={() => updateEmptyContext(TTSContextType.SUCCESS_EMPTY)}
          />
        )}
        {isShowButtonInitError && (
          <Controls.Button
            text="Init Empty Context Error"
            variant="outlined"
            startIcon={<RestartAltIcon />}
            color="warning"
            onClick={() => initEmptyContextError(TTSContextType.ERROR_EMPTY)}
          />
        )}
        {isShowButtonUpdateError && (
          <Controls.Button
            text="Update Empty Context"
            variant="outlined"
            startIcon={<RestartAltIcon />}
            color="warning"
            onClick={() => updateEmptyContextError(TTSContextType.ERROR_EMPTY)}
          />
        )}
        {allowedToCreateEntity(auth?.permissions, permissionsAccessControl) && (
          <Controls.Button
            text="Add New"
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={() => handleOpenPopup(isOpenPopup, null)}
          />
        )}
      </div>
    </div>
  );
};

export default TTSContextControlPanel;
